/**
 * Service: walkinsApi
 */
angular.module('acme.common.service.walkinsApi', [])
.service('WalkinsApiService', [ '$http', function($http) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/walkin';
        this.orders.service = this.service + '/orders';
        this.sources.service = this.orders.service + '/sourcenames';
        return this;
      },

      orders: {

        service: '',

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: {
              eventId: props.eventId,
              contactFirstName: props.contactFirstName,
              contactLastName: props.contactLastName,
              sourceName: props.sourceName,
              notes: props.notes,
              items: props.items
            }
          });
        }

      },

      sources: {

        service: '',

        detail: function() {
          return $http({
            method: 'get',
            url: this.service
          });
        }

      }


    };

}]);